/** Desktop table shell — header stays fixed; only tbody rows scroll. */
export const desktopTableShellClass =
  "desktop-table-shell hidden overflow-x-auto rounded-xl border md:block";

/** Paginated list pages — shorter body height so pagination stays on screen. */
export const desktopPaginatedTableShellClass =
  "desktop-table-shell desktop-table-shell--paginated hidden overflow-x-auto rounded-xl border md:block";

/** Apply to Table — enables tbody-only vertical scroll via global CSS. */
export const desktopScrollTableClass = "desktop-scroll-table w-full";

/** Members & Groups — classic full-table scroll (avoids tbody layout distortion). */
export const classicTableOuterClass =
  "hidden overflow-hidden rounded-xl border md:block";

export const classicTableScrollClass =
  "overflow-auto max-h-[calc(100dvh-280px)]";

export const classicStickyTableHeaderClass =
  "sticky top-0 z-10 bg-[#D8DDE6] [&_th]:bg-[#D8DDE6]";
